import React from "react";
import "./Home.css";
import Header2 from "../../components/header/Header2";
import HeroSection from "../../components/herosection/Herosection";
import ShortAbout from "../../components/short_about/ShortAbout";
import ShortServicesOverview from "../../components/short_services_overview/ShortServicesOverview";
import ShortIndustriesWeServe from "../../components/short_industries_we_serve/ShortIndustriesWeServe";
import ShortWhyChooseUS from "../../components/short_why_choose_us/ShortWhyChooseUS";
import ShortTechnologyStack from "../../components/short_technology_stack/ShortTechnologyStack";
import Footer from "../../components/footer/Footer";
import WhatsappCallBtn from "../../components/whatsapp_call_btn/WhatsappCallBtn";
import { Helmet } from "react-helmet";
export default function Home() {
  return (
    <>
     <Helmet>
  <title>
    GlassHopeOne Technologies Pvt. Ltd. | Enterprise Software, SaaS & Mobile App Development Company
  </title>

  <meta
    name="description"
    content="GlassHopeOne Technologies Pvt. Ltd. is an enterprise technology company building scalable software solutions, SaaS platforms, web applications, and mobile apps. We help businesses innovate, automate operations, and grow digitally."
  />

  <meta
    name="keywords"
    content="enterprise software development, SaaS product development, web application development, mobile app development company, custom software solutions, enterprise IT services, software company India, GlassHopeOne Technologies, technology solutions provider"
  />

  <meta name="author" content="GlassHopeOne Technologies Pvt. Ltd." />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  {/* Canonical */}
  <link rel="canonical" href="https://www.glasshopeone.com/" />

  {/* SaaS Product Association (brand signal, not SEO competition) */}
  <link
    rel="alternate"
    href="https://www.calake360.com"
    title="CA Lake360 – Chartered Accountant Work Management System SaaS by GlassHopeOne Technologies"
  />
</Helmet>

      <Header2 />
      <HeroSection />
      <ShortAbout />
      <ShortServicesOverview />
      <ShortIndustriesWeServe />
      <ShortWhyChooseUS />
      <ShortTechnologyStack />
      <WhatsappCallBtn />
      <Footer />
    </>
  );
}
